var map = {
	"./cart.svg": "6f5d",
	"./cross.svg": "89fe",
	"./external_link.svg": "8e00",
	"./eye.svg": "83a4",
	"./loading_wave.svg": "4c49",
	"./plus.svg": "8a37",
	"./refresh.svg": "b7d8",
	"./tick.svg": "4ab9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31e8";